import React, { Component } from "react";
import { Dropdown, DropdownMenu, DropdownItem, DropdownToggle } from "reactstrap";
import { getMessage } from "CONFIG/i18n";

import "./Menu.less"

import ic_picture_in_picture from "ASSETS/Images/video_menu/ic_picture_in_picture.svg";
import ic_fullscreen from "ASSETS/Images/video_menu/ic_switch_full_screen.svg";
import ic_audio_settings from "ASSETS/Images/video_menu/ic_config.svg";
import ic_video_menu from "ASSETS/Images/video_menu/ic_videoMenu.svg";

export default class VideoMenu extends Component {
  constructor(props) {
    super(props);
    this.state={
      show: false,
    }
  }

  toggle = () => {
    this.setState({ show: !this.state.show})
  }

  handlePictureInPicture = () => {
    this.props.handlePictureInPicture();
  }

  handleFullScreen = () => {
    this.props.handleFullScreen();
  }

  handleVideoSetting = () => {
    this.props.handleVideoSettingModalShow();
  }

  render() {
    return (
      <Dropdown isOpen={this.state.show} toggle={this.toggle} direction="down">
        <DropdownToggle className="toggle mr-2 pr-0 pl-2" onClick={this.toggle}>
          {" "}
          <img
            src={ic_video_menu}
            id="videoMenu"
            title={getMessage("MENU")}
          />
        </DropdownToggle>

        <DropdownMenu right>
          <DropdownItem onClick={this.handleVideoSetting}>
            <img src={ic_audio_settings} className="icons"/>
            {" " + getMessage("AUDIO_SETTING")}
          </DropdownItem>

          { this.props.isPictureInPictureEnable &&
            <DropdownItem onClick={this.handlePictureInPicture}>
              <img src={ic_picture_in_picture} className="icons"/>
              {" " + getMessage("TOOLTIP_PICTURE_IN_PICTURE")}
            </DropdownItem>
          }

          { this.props.isFullScreenEnable &&
            <DropdownItem onClick={this.handleFullScreen}>
              <img src={ic_fullscreen} className="icons"/>
              {" " + getMessage("SCREEN_ZOOMIN")}
            </DropdownItem>
          }

        </DropdownMenu>
      </Dropdown>
    )
  }
}